import store from "@/store";
import { USER_TRACK_EVENTS } from "@/store/modules/user/consts";

/**
 * Structured activity log (same payload shape as manual USER_TRACK_EVENTS dispatches).
 * @param {{ current: string, activity: string, next?: string, meta?: object }} data
 */
export async function logEvent(data) {
  const meta = { ...(data.meta || {}), pathname: window.location.pathname };
  try {
    await store.dispatch(`user/${USER_TRACK_EVENTS}`, {
      moduleInfo: {
        current: data.current,
        activity: data.activity,
        next: data.next,
        meta,
      },
    });
  } catch (err) {
    console.debug("[obs] logEvent failed", err);
  }
}
